<section class="cmn-innerpage-wrapper project-new">
  <form [formGroup]="projectForm" (ngSubmit)="onSubmit()">
    <h2 class="cmn-inner-heading">
      {{ projectId ? "Project Edit" : "Project New" }}
    </h2>
    <div class="invoice-new-form-wrapper">
      <div class="invoice-form-wrapper">
        <div class="form-wrapper">
          <label for="">Project Name <span class="red">*</span></label>
          <mat-form-field>
            <input
              matInput
              placeholder="Enter name"
              formControlName="projectName"
            />
          </mat-form-field>
          <div
            class="custom-error"
            *ngIf="projectForm.get('projectName')!.touched"
          >
            <span>
              <mat-error
                *ngIf="projectForm.get('projectName')?.hasError('required')"
              >
                Project name is required
              </mat-error>
            </span>
          </div>
        </div>

        <div class="form-wrapper">
          <label for="">Project Code <span class="red">*</span></label>
          <mat-form-field>
            <input
              matInput
              placeholder="000102"
              formControlName="projectCode"
              readonly
            />
          </mat-form-field>
          <div
            class="custom-error"
            *ngIf="projectForm.get('projectCode')!.touched"
          >
            <span>
              <mat-error
                *ngIf="projectForm.get('projectCode')?.hasError('required')"
              >
                Project code is required
              </mat-error>
            </span>
          </div>
        </div>

        <div class="form-wrapper">
          <label for="">Quote Code <span class="red">*</span></label>
          <mat-form-field>
            <input
              matInput
              placeholder="Enter quote code"
              formControlName="quoteCode"
            />
          </mat-form-field>
          <div
            class="custom-error"
            *ngIf="projectForm.get('quoteCode')!.touched"
          >
            <span>
              <mat-error
                *ngIf="projectForm.get('quoteCode')?.hasError('required')"
              >
                Quote code is required
              </mat-error>
            </span>
          </div>
        </div>

        <div class="form-wrapper">
          <label for="">Order Code <span class="red">*</span></label>
          <mat-form-field>
            <input
              matInput
              placeholder="Enter order code"
              formControlName="orderCode"
            />
          </mat-form-field>
          <div
            class="custom-error"
            *ngIf="projectForm.get('orderCode')!.touched"
          >
            <span>
              <mat-error
                *ngIf="projectForm.get('orderCode')?.hasError('required')"
              >
                Order code is required
              </mat-error>
            </span>
          </div>
        </div>

        <div class="form-wrapper">
          <label for="">First Name <span class="red">*</span></label>
          <mat-form-field>
            <input
              matInput
              placeholder="Enter first name"
              formControlName="firstName"
            />
          </mat-form-field>
          <div
            class="custom-error"
            *ngIf="projectForm.get('firstName')!.touched"
          >
            <span>
              <mat-error
                *ngIf="projectForm.get('firstName')?.hasError('required')"
              >
                First name is required
              </mat-error>
            </span>
          </div>
        </div>

        <div class="form-wrapper">
          <label for="">Last Name <span class="red">*</span></label>
          <mat-form-field>
            <input
              matInput
              placeholder="Enter last name"
              formControlName="lastName"
            />
          </mat-form-field>
          <div
            class="custom-error"
            *ngIf="projectForm.get('lastName')!.touched"
          >
            <span>
              <mat-error
                *ngIf="projectForm.get('lastName')?.hasError('required')"
              >
                Last name is required
              </mat-error>
            </span>
          </div>
        </div>

        <div class="form-wrapper">
          <label for="">Project Cost <span class="red">*</span></label>
          <mat-form-field>
            <input
              matInput
              placeholder="Enter cost"
              formControlName="projectCost"
              type="number"
            />
          </mat-form-field>
          <div
            class="custom-error"
            *ngIf="projectForm.get('projectCost')!.touched"
          >
            <span>
              <mat-error
                *ngIf="projectForm.get('projectCost')?.hasError('required')"
              >
                Project cost is required
              </mat-error>
            </span>
          </div>
        </div>

        <!-- Start Date -->
        <div class="form-wrapper">
          <label for="">Start Date <span class="red">*</span></label>
          <mat-form-field>
            <input
              matInput
              [matDatepicker]="startPicker"
              placeholder="Choose start date"
              formControlName="startDate"
              [matDatepickerFilter]="startDateFilter"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="startPicker"
            ></mat-datepicker-toggle>
            <mat-datepicker #startPicker></mat-datepicker>
          </mat-form-field>
          <div
            class="custom-error"
            *ngIf="projectForm.get('startDate')!.touched"
          >
            <span>
              <mat-error
                *ngIf="projectForm.get('startDate')?.hasError('required')"
              >
                Start date is required
              </mat-error>
            </span>
          </div>
        </div>

        <!-- End Date -->
        <div class="form-wrapper">
          <label for="">End Date <span class="red">*</span></label>
          <mat-form-field>
            <input
              matInput
              [matDatepicker]="endPicker"
              placeholder="Choose end date"
              formControlName="endDate"
              [matDatepickerFilter]="endDateFilter"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="endPicker"
            ></mat-datepicker-toggle>
            <mat-datepicker #endPicker></mat-datepicker>
          </mat-form-field>
          <div class="custom-error" *ngIf="projectForm.get('endDate')!.touched">
            <span>
              <mat-error
                *ngIf="projectForm.get('endDate')?.hasError('required')"
              >
                End date is required
              </mat-error>
            </span>
          </div>
        </div>
      </div>
    </div>

    <div class="submit-btn-wrapper">
      <button type="button" class="cmn-cancel-btn" (click)="onClearForm()">
        Cancel
      </button>
      <button class="cmn-next-btn" [disabled]="loading">Save</button>
    </div>
  </form>
</section>
